// extracted by mini-css-extract-plugin
export default {"main":"ModalNuevoVideo_main__knGWT","intro":"ModalNuevoVideo_intro__ZxWjL","input":"ModalNuevoVideo_input__Cs1cP"};